// Single source of truth for a bank statement's one-glance reconciliation
// status, shared by the Reconciliation Inbox and the Bank Statements list so
// both always show the SAME status for the same statement.
//
// Counts come from the existing GET /recon/inbox payload
// (txn_count / linked_count / open_count — the same _txn_already_linked
// predicate the "{done} of {total} reconciled" progress bar uses). No second
// definition of reconciled / linked / open / needs-action.
export function statementStatus(s) {
  const total = s?.txn_count || 0;
  const done = s?.linked_count || 0;
  const open = s?.open_count != null ? s.open_count : total - done;
  if (total === 0) return { key: 'empty', dot: 'bg-slate-300', textCls: 'text-slate-400', label: 'No transactions' };
  if (done === 0) return { key: 'pending', dot: 'bg-slate-400', textCls: 'text-slate-500', label: 'Not started' };
  if (open <= 0) return { key: 'done', dot: 'bg-emerald-500', textCls: 'text-emerald-600', label: 'All linked' };
  return { key: 'partial', dot: 'bg-amber-500', textCls: 'text-amber-600', label: `${open} open` };
}
